/* global $ */

/**
 * Header mouse on
 */
$('#rightSolvable').hover(() => {
  $('.header-f-background').toggleClass('active');
  $('.leftSolvable').toggleClass('active');
  $('.header-r-background').toggleClass('active');
  $('.rightSolvable').toggleClass('active');
});

/**
 * solvable
 */
// left
$('#scriptProject').hover(() => {
  $('.business-project .items-script-left').toggleClass('open');
  $('.business-project .items-text-left').toggleClass('open');
  $('.business-project .brush').toggleClass('open');
});

$('#scriptSkill').hover(() => {
  $('.business-skill .items-script-left').toggleClass('open');
  $('.business-skill .items-text-left').toggleClass('open');
  $('.business-skill .brush').toggleClass('open');
});

$('#scriptTaleat').hover(() => {
  $('.business-taleat .items-script-left').toggleClass('open');
  $('.business-taleat .items-text-left').toggleClass('open');
  $('.business-taleat .brush').toggleClass('open');
});

// right
$('#scriptPayment').hover(() => {
  $('.business-payment .items-script-right').toggleClass('open');
  $('.business-payment .items-text-right').toggleClass('open');
  $('.business-payment .brush').toggleClass('open');
});

$('#scriptWorkflow').hover(() => {
  $('.business-workflow .items-script-right').toggleClass('open');
  $('.business-workflow .items-text-right').toggleClass('open');
  $('.business-workflow .brush').toggleClass('open');
});

$('#scriptClient').hover(() => {
  $('.business-client .items-script-right').toggleClass('open');
  $('.business-client .items-text-right').toggleClass('open');
  $('.business-client .brush').toggleClass('open');
});

/**
 * solvable mobile
 */

// switch button
$('#btnArrowLeft').click((e) => {
  e.preventDefault();

  $('.business-payment').parent().find('div').removeClass('open');

  $('.mLeftSolvable').toggleClass('open');
  $('.mRightSolvable').toggleClass('open');
  $('.leftSolvable-img').toggleClass('open');
  $('.rightSolvable-img').toggleClass('open');
});

$('#btnArrowRight').click((e) => {
  e.preventDefault();

  $('.business-project').parent().find('div').removeClass('open');

  $('.mLeftSolvable').toggleClass('open');
  $('.mRightSolvable').toggleClass('open');
  $('.leftSolvable-img').toggleClass('open');
  $('.rightSolvable-img').toggleClass('open');
});

// touch to show text (left)
$('#business-items-left-m').click((e) => {
  if (e.target.nodeName !== 'IMG') return;

  const { block } = e.target.dataset;
  const { business } = e.target.dataset;
  const { text } = e.target.dataset;

  $(`.${block}`).parent().find('div').removeClass('open');

  $(`.${block} .${business}`).toggleClass('open');
  $(`.${block} .${text}`).toggleClass('open');
  $(`.${block} .brush`).toggleClass('open');
});

// touch to show text (right)

$('#business-items-right-m').click((e) => {
  if (e.target.nodeName !== 'IMG') return;

  const { block } = e.target.dataset;
  const { business } = e.target.dataset;
  const { text } = e.target.dataset;

  $(`.${block}`).parent().find('div').removeClass('open');

  $(`.${block} .${business}`).toggleClass('open');
  $(`.${block} .${text}`).toggleClass('open');
  $(`.${block} .brush`).toggleClass('open');
});
